import React from 'react'

export default function LocalizeButton({onClick}) {
    return (
        <div style={ styles.button }
             onClick={onClick}>
            <i className="fa fa-location-arrow"/>
        </div>

    )
}

const styles = {
    button: {
        width: '50px',
        height: '50px',
        backgroundColor: 'white',
        borderRadius: '100%',
        position: 'absolute',
        bottom: '20px',
        right: '10px',
        color: '#ff420d',
        padding: '2px',
        textAlign: 'center',
        fontSize: '30px',
        boxShadow: '0px 1px 5px grey'
    }
};